export const TIMEZONES = [
  { value: 'Pacific/Midway', label: '(UTC-11:00) Midway Island' },
  { value: 'Pacific/Honolulu', label: '(UTC-10:00) Hawaii' },
  { value: 'America/Anchorage', label: '(UTC-09:00) Alaska' },
  { value: 'America/Los_Angeles', label: '(UTC-08:00) Pacific Time (US)' },
  { value: 'America/Denver', label: '(UTC-07:00) Mountain Time (US)' },
  { value: 'America/Chicago', label: '(UTC-06:00) Central Time (US)' },
  { value: 'America/New_York', label: '(UTC-05:00) Eastern Time (US)' },
  { value: 'America/Sao_Paulo', label: '(UTC-03:00) Brasilia' },
  { value: 'Atlantic/Azores', label: '(UTC-01:00) Azores' },
  { value: 'Europe/London', label: '(UTC+00:00) London, Dublin' },
  { value: 'Europe/Paris', label: '(UTC+01:00) Paris, Berlin, Rome' },
  { value: 'Europe/Helsinki', label: '(UTC+02:00) Helsinki, Cairo' },
  { value: 'Europe/Moscow', label: '(UTC+03:00) Moscow, Riyadh' },
  { value: 'Asia/Dubai', label: '(UTC+04:00) Dubai, Abu Dhabi' },
  { value: 'Asia/Karachi', label: '(UTC+05:00) Karachi, Islamabad' },
  { value: 'Asia/Kolkata', label: '(UTC+05:30) Mumbai, New Delhi, Kolkata' },
  { value: 'Asia/Kathmandu', label: '(UTC+05:45) Kathmandu' },
  { value: 'Asia/Dhaka', label: '(UTC+06:00) Dhaka' },
  { value: 'Asia/Bangkok', label: '(UTC+07:00) Bangkok, Jakarta' },
  { value: 'Asia/Singapore', label: '(UTC+08:00) Singapore, Hong Kong' },
  { value: 'Asia/Tokyo', label: '(UTC+09:00) Tokyo, Seoul' },
  { value: 'Australia/Sydney', label: '(UTC+10:00) Sydney, Melbourne' },
  { value: 'Pacific/Auckland', label: '(UTC+12:00) Auckland' },
] as const;

export type TimezoneOption = (typeof TIMEZONES)[number];

export function formatTimezoneLabel(timezone: TimezoneOption): string {
  return `${timezone.value} - ${timezone.label}`;
}
